/**
 * exatrek REST API
 * Some custom description of API.
 *
 * The version of the OpenAPI document: v3
 * Contact: dev@exatrek.de
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

export interface CanValueMappingDto {
  formula?: string;
  neededCanValues?: { [key: string]: string };
  parameterName?: string;
  parameterUnit?: string;
}
